module.exports = __webpack_public_path__ + "static/media/Header_teacher_Mobile.337b674e.jpg";